<template>
  <article class="popup add-new-journal-popup">
    <header class="popup-top">
      <h2 class="title">Бортовой журнал</h2>
      <div class="popup-top_btns">
        <question-btn :text="$t('labels.prompt')"></question-btn>
        <close-btn class="static"></close-btn>
      </div>
    </header>
    <div class="popup-middle">
      <label class="input-cont input-cont_small">
        <p class="label">Название журнала*</p>
        <input type="text"
               @blur="$v.name.$touch()"
               @focus="$v.name.$reset()"
               placeholder="Тестов|">
        <!--          <errors v-show="$v.name.$error"></errors>-->
      </label>
    </div>
    <div class="popup-down">
      <button class="btn btn-transparent_blue">Отменить</button>
      <button class="btn btn-blue">Добавить</button>
    </div>
  </article>
</template>

<script>
  import closeBtn from '../closeBtn'
  import questionBtn from '../questionBtn'
  import {popups} from "../../../mixins/popups";

  export default {
    name: "addNewJournal",
    mixins: [popups],
    components: { closeBtn, questionBtn }
  }
</script>

<style lang="scss" scoped>
  .add-new-journal-popup {
    width: 360px !important;
    max-width: none !important;
    padding: 30px !important;
  }
  .popup-top {
    padding-bottom: 30px;
    margin-bottom: 40px !important;
  }
  .popup-down {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    .btn {
      width: 170px;
    }
  }
</style>
